<template>
	<!--TODO translations-->
	<div class="flex-fill text-green font-bold p-3 text-center">
		<span v-if="meta.trade == 'BUY'">
			{{
				__(
					"Bids are binding until the end of their validity. A contract is concluded with confirmation from the seller."
				)
			}}
		</span>
		<span v-else>
			{{
				__(
					"Offers are binding until the end of their validity. A contract is concluded with confirmation from the buyer."
				)
			}}
		</span>
		{{ __("messages.entering_contract", { args: { par: cropFeeEstimate } }) }}
		<!--{{ __('Bei Abschluss dieses Kontrakts wird Ihnen eine Kommission in Höhe von') }} {{ cropFeeEstimate }}
			€ {{ __('pro Tonne in Rechnung gestellt.') }}-->
	</div>
</template>

<script>
export default {
	props: {
		bid: {
			type: Object,
			required: true,
		},
		meta: {
			type: Object,
			required: false,
		},
		isBid: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		cropFeeEstimate() {
			let commission =
				this.meta.trade == "BUY"
					? this.bid.commission.buyer_mt
					: this.bid.commission.seller_mt;
			console.log(commission);
			return (commission * 1).toFixed(2).replace(".", ",");
		},
		bidTitle() {
			let label =
				this.meta.trade == "BUY"
					? this.__("This offer")
					: this.__("This offer to the seller");
			return label;
		},
	},
};
</script>
